<template>
  <div class="content-wrap">
    <kapp-header id="mainHeader" :show-header="true"></kapp-header>

    <template v-if="content.length">
      <template v-for="(contentBlock,uid) in content">

        <master-block v-if="contentBlock.ctype != 'list'" :data="contentBlock" :seamless="true"
                      :key="uid + '_' + contentBlock.title"></master-block>
        <div v-else :key="uid + '_' + contentBlock.title">
          <fragebogen v-if="!submitted" :questions="questions" :url="submitUrl"></fragebogen>

          <div class="content-block" v-show="submitted && isSending">
            <div class=" block block--seamless">
              <p class="message message--info">Daten werden abgeschickt.</p>
            </div>
          </div>

          <div class="content-block" v-show="submitted && !isSending">
            <div class=" block block--seamless">
              <p class="message message--info">Danke f&uuml;r Ihre Abstimmung</p>
            </div>
          </div>
        </div>

      </template>
    </template>
  </div>
</template>

<script>
	import Header from '../components/layouts/Header';

	import api, { ApiDefaults } from '../utils/api_call';
	import { BAROMETER_SUBMIT } from '../utils/store/actions/general';
	import MasterBlock from "../components/blocks/MasterBlock";
	import Fragebogen from "../components/subparts/Fragebogen";

	export default {
		name: "KappBarometer",
		data() {
			return {
				questions: [
					// {
					// 	title: 'Ich bin zufrieden',
					// 	question: 'Wie zufrieden bist Du aktuell mit Deinem Arbeitsalltag?',
					// 	name: 'tx_powermail_pi1[field][zufriedenarbeitsaltag]',
					// 	type: 'rate',
					// 	answers: {from: 0, to: 100, steps: 4},
					// 	result: null
					// },
					// {
					// 	title: 'Ich bin Kassecker',
					// 	question: 'Wie verbunden fühlst Du Dich aktuell\n' +
					// 		'mit Kassecker?',
					// 	name: 'tx_powermail_pi1[field][verbundenmitkassecker]',
					// 	type: 'rate',
					// 	answers: {from: 0, to: 100, steps: 4},
					// 	result: null
					// },
					// {
					// 	name: '',
					// 	type: 'group',
					// 	title: 'Ich bin stolz',
					// 	questions: [
					// 		{
					// 			question: 'Wie gut kannst Du Dich aktuell einbringen?',
					// 			name: 'tx_powermail_pi1[field][stolzleistung]',
					// 			type: 'rate',
					// 			answers: {from: 0, to: 100, steps: 4},
					// 			result: null
					// 		},
					// 		{
					// 			title: 'Ich bin stolz',
					// 			question: 'Wie stolz bist Du derzeit\n' +
					// 				'auf Dein Team?',
					// 			name: 'tx_powermail_pi1[field][stolzteam]',
					// 			type: 'rate',
					// 			answers: {from: 0, to: 100, steps: 4},
					// 			result: null
					// 		}
					// 	]
					// },
					// {
					// 	title: 'Was möchtest du uns noch sagen?',
					// 	question: '',
					// 	name: 'tx_powermail_pi1[field][wasmchtestduunsnochsagen]',
					// 	type: 'text',
					// 	answers: '',
					// 	result: null
					// },
					// {
					// 	title: 'Bitte ordne Dich gemäß Deinem aktuellen Tätigkeitsbereich zu',
					// 	question: '',
					// 	name: 'tx_powermail_pi1[field][marker01]',
					// 	type: 'choose_info',
					// 	answers: [
					// 		'Hochbau',
					// 		'Tiefbau',
					// 		'Bahn-/ingenieurbau',
					// 		'Stahl-und Metallbau',
					// 		'Zentraler-Bereich(z.B kaufm. Verwaltung/MT...)'
					// 	],
					// 	result: null
					// }
				],
				content: [],
				resultData: {},
				submitted: this.$store.getters.barometerSubmitted,
				isSending: false,
				active: true,
				submitUrl: ''
			};
		},
		props: [],
		computed: {
			showForm: function () {
				return !this.$store.getters.barometerSubmitted;
			}
		},
		methods: {
			track() {
				this.$ga.page('/barometer');
			},
			fetchData: function () {

				let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: 10}});
				api(apiParams).then(( response ) => {
					/**
					 * @var {Object} response
					 * @var {Object} response.data
					 * @var {Array} response.data.fragen
					 * */
					this.submitUrl = response.data.submitUrl;
					this.content = response.data.content;

					/** @var {string} name */
					if ( response.data.hasOwnProperty('fragen') ) {
						this.checkSubmission();
						this.questions = response.data.fragen;
					}

					/** ToDo: preheat resultData with default value */
				});
			},
			checkSubmission: function () {
				let data = this.content.find(
					( cnt ) => (cnt.ctype === 'list' && cnt.listType === 'c3barometer_fragebogen')),
					submitted = this.$store.getters.barometerSubmitted; /** @var integer  unixtimestamp */

				if ( submitted !== false && data.startTime !== null ) {
					data.startTime.date = data.startTime.date.replace(' ', 'T');
					let d = Date.parse(data.startTime.date);
					if ( typeof d === 'number' ) {
						d = d / 1000;
						// console.log( d, submitted );
						if ( d > submitted ) {
							this.$store.commit(BAROMETER_SUBMIT, false);
						}
					}
				}

			}
		},
		created() {
			this.fetchData();
		},
		mounted() {

			this.$store.watch(
				( state, getters ) => getters.barometerSubmitted,
				( newVal ) => {
					this.submitted = !!(newVal); /** @var bool */
				}
			);
		},
		components: {
			'kapp-header': Header,
			'master-block': MasterBlock,
			'fragebogen': Fragebogen
		}
	};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/KappBarometer.vue